import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { ReportsRoutingModule } from './reports-routing.module';
import { OrdersreportsComponent } from './ordersreports/ordersreports.component';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { MandoobsstatmentComponent } from './mandoobsstatment/mandoobsstatment.component';
import { OrdersbycategoryComponent } from './ordersbycategory/ordersbycategory.component';
import { OrdersbysubcategoryComponent } from './ordersbysubcategory/ordersbysubcategory.component';
import { OrdersbyproductComponent } from './ordersbyproduct/ordersbyproduct.component';
import { OrdersMandoobPrivateComponent } from './orders-mandoob-private/orders-mandoob-private.component';
import { OrdersdirectchargedComponent } from './ordersdirectcharged/ordersdirectcharged.component';
import { OrdersbyuserComponent } from './ordersbyuser/ordersbyuser.component';
import { UsertransComponent } from './usertrans/usertrans.component';
import { GetbyorderidComponent } from './getbyorderid/getbyorderid.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ProductcardsreportComponent } from './productcardsreport/productcardsreport.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import { UsertransallComponent } from './usertransall/usertransall.component';
import { MandoobstransComponent } from './mandoobstrans/mandoobstrans.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GalaxyInterceptor } from '../galaxy.interceptor';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ServicepayordersComponent } from './servicepayorders/servicepayorders.component';
import { MandoobcustomersDepositsComponent } from './mandoobcustomers-deposits/mandoobcustomers-deposits.component';
import { ProductcardsinventoryComponent } from './productcardsinventory/productcardsinventory.component';


@NgModule({
  declarations: [OrdersreportsComponent, MatspinnerComponent, MandoobsstatmentComponent,
    OrdersbycategoryComponent, OrdersbysubcategoryComponent, OrdersbyproductComponent,
    OrdersMandoobPrivateComponent, OrdersdirectchargedComponent, OrdersbyuserComponent,
    UsertransComponent, GetbyorderidComponent, ProductcardsreportComponent,
    UsertransallComponent,
    MandoobstransComponent,
    ServicepayordersComponent,
    MandoobcustomersDepositsComponent,
    ProductcardsinventoryComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReportsRoutingModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LayoutModule,
    MatIconModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatPaginatorModule,
    MatGridListModule,
    MatTableModule,
    MatDatepickerModule,
    NgxWebstorageModule.forRoot(),
    TranslateModule,
    FlexLayoutModule,
    MatDividerModule,
    MatTableExporterModule,
    MatAutocompleteModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GalaxyInterceptor,
      multi: true
    },
  ]
})
export class ReportsModule { }
